import { Controller } from "@hotwired/stimulus"

export default class extends Controller<HTMLElement> {
  static targets = ["monthField"]

  declare readonly hasMonthFieldTarget: boolean
  declare readonly monthFieldTarget: HTMLElement

  connect() {
    const scheduledCheckbox = this.element.querySelector<HTMLInputElement>(
      'input[name="availability_statuses[]"][value="scheduled"]',
    )

    this.updateMonthField(scheduledCheckbox?.checked ?? false)
  }

  toggle(event: Event) {
    this.updateMonthField((event.currentTarget as HTMLInputElement).checked)
  }

  updateMonthField(visible: boolean) {
    if (this.hasMonthFieldTarget) {
      this.monthFieldTarget.classList.toggle("hidden", !visible)
    }
  }
}
